import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { t } from '@lingui/macro';
import Helmet from '../../components/SEO/Helmet';
import SharedSettingForm from './SharedSettingForm';

export default function SharedSettingEditPage() {
  const navigate = useNavigate();
  const { uuid } = useParams();

  return (
    <>
      <Helmet
        title={t`Edit Shared Setting`}
        description={t`Edit a shared attribute mapping profile`}
      />
      <SharedSettingForm
        editingId={uuid}
        onBack={() => navigate('/toolkit/shared_settings')}
      />
    </>
  );
}
